import { __ } from '@wordpress/i18n';
import axios from 'axios';
import apiFetch from '@wordpress/api-fetch';
import { isEmpty } from 'lodash';



export const updateOption = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/updateOption',
            method: 'POST',
            data: {
                ...params
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const updateMailChimp = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/updateMailChimp',
            method: 'POST',
            data: {
                ...params
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getGlobalStyle = () => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/getGlobalStyle',
            method: 'GET'
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getOption = (name) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: `/jkit/v1/getOption?name=${encodeURIComponent(name)}`,
            method: 'GET'
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getTemplateLists = (type) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: `/jkit/v1/getTemplateLists?type=${encodeURIComponent(type)}`,
            method: 'GET'
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const dashboardSave = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/themeOptions',
            method: 'POST',
            data: {
                setting: Object.assign({}, params),
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};


/* coppyed from Proficient */

export const httpClient = (apiUrl) => axios.create({
    baseURL: apiUrl
});

export const fetchDemoData = () => {
  return apiFetch({
    path: 'jkit/v1/demo/data',
    method: 'GET',
  });
};

export const fetchDemoCategories = () => {
  return apiFetch({
    path: 'jkit/v1/demo/categories',
    method: 'POST',
  });
};

export const saveDemoLikeState = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/demo/like-state',
            method: 'POST',
            data: {
                ...params
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const saveDemoImportState = (params) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/demo/import-state',
            method: 'POST',
            data: {
                ...params
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};



export const getConfig = (demo) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/demos/getConfig',
            method: 'POST',
            data: {
                nonce: '',
                demo: demo,
                domain: window.location.hostname,
                code: '',
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const installPlugins = (plugin) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/managePlugin',
            method: 'POST',
            data: {
                code: '',
                nonce: '',
                plugin: plugin,
            },
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getContent = (demo, content) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/getContent',
            method: 'POST',
            data: {
                nonce: '',
                demo: demo,
                content: content,
            },
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const importImage = (demo, image) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/manageImage',
            method: 'POST',
            data: {
                nonce: '',
                image: image,
                demo: demo,
            },
        }).then(response => {
            resolve(response);
        }).catch(error => {
            resolve({ status: __('Downloading Images', 'jkit') });
            // reject(error);
        });
    });
};

export const importContent = (demo, action, content) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/manageContent',
            method: 'POST',
            data: {
                nonce: '',
                action: action,
                data: content.content,
                demo: demo,
            },
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const importStyle = (title, demo, action, content) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/manageContent',
            method: 'POST',
            data: {
                nonce: '',
                title: title,
                data: content,
                action: action,
                demo: demo,
            },
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const uninstallContent = (type, demo, action) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/manageContent',
            method: 'POST',
            data: {
                nonce: '',
                action: action,
                demo: demo,
                type: type,
            },
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

export const subscribeNewsletter = (email, site) => {
    return new Promise((resolve, reject) => {
        apiFetch({
            path: 'jkit/v1/newsletter-subscribe',
            method: 'POST',
            data: {
                email: email,
                site: site
            }
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};


export const closeBanner = (setClose) => {
    const { bannerNonce } = window['JkitDashboardOption'] || {};
    apiFetch({
        path: 'jkit/v1/close-banner',
        method: 'POST',
        data: {
            nonce: bannerNonce,
        }
    }).then(response => {
        setClose(true);
        return;
    }).catch(error => {
        setClose(true);
        console.warn('Faild when close banner');
        return;
    });
};